import { resolveImageUrl } from '../services/api'
import type { AllergenInfo } from '../contexts/RestaurantContext'

interface AllergenIconsProps {
  allergenIds: string[]
  allergenMap: Record<string, AllergenInfo>
  className?: string
  size?: number
}

/** Renders allergen icons only; name shown on hover (title). */
export default function AllergenIcons({ allergenIds, allergenMap, className = '', size = 20 }: AllergenIconsProps) {
  if (!allergenIds?.length) return null
  return (
    <div className={`flex flex-wrap items-center gap-1 ${className}`} role="list" aria-label="Allergens">
      {allergenIds.map((id) => {
        const info = allergenMap[id]
        if (!info) return null
        const name = info.name || 'Allergen'
        const iconUrl = info.icon ? resolveImageUrl(info.icon) : null
        return (
          <span
            key={id}
            role="listitem"
            className="inline-flex items-center justify-center rounded overflow-hidden bg-gray-100 shrink-0"
            title={name}
            style={{ width: size, height: size }}
          >
            {iconUrl ? (
              <img src={iconUrl} alt="" className="w-full h-full object-contain" aria-hidden />
            ) : (
              <span className="text-[10px] font-medium text-gray-500" aria-hidden>?</span>
            )}
          </span>
        )
      })}
    </div>
  )
}
